import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Input, AutoComplete, Tag, notification } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import withTranslations from 'app/components/HOGs/withTranslations';
import { setFullScreenModeStatus } from 'app/actions/FullTour/full_tour_view.action';
import { Type } from 'app/constants/TourPoints';
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import { getTourPointAddress } from 'app/API/autocomplete';
import { setHomeAddressUser } from 'actions/Users/users.action';
import mapUtils from '../../../../libs/Utils/mapUtils';
import EmbedTourModal from '../Tools/EmbedTour';
import {
  HomeStartIcon,
  HomeEndIcon,
  WorkStartIcon,
  WorkEndIcon,
  DownloadPdfTourIcon,
  EmbedTourIcon,
  RevertTourIcon,
  FullScreenTourIcon,
  ShowEntireTourIcon,
  HomeSetPositionIcon,
} from '../../MainMenu/svg';
import TimeAndDistanceAccumulated from '../Tools/TimeAndDistanceAccumulated';
import TimeAndDistanceBetweenPoints from '../Tools/TimeAndDistanceBetweenPoints';

import '../tourFull.css';

const SetAddressField = ({
  isActive,
  setActive,
  setHomeAddress,
  homeAdr,
  workAdr,
  isHome,
  tr,
}) => {
  const [result, setResult] = useState([]);

  const handleSelect = (value, el) => {
    const { rel, children } = el.props;
    const { lat, lng } = rel;
    const point = {
      value: children,
      lat,
      lng,
    };
    setActive(false);
    mapUtils.getTourstartGeocoder({ id: Type.HOME, lat, lng }, (e) => {
      point.loc = e.data;
      setHomeAddress(point);
    });
    publish(way.DRIVE_CHANGE_CURSOR_ICON, {});
  };

  const update = (list) => {
    setResult(() => [...list]);
  };

  const handleSearch = (value) => {
    let result = [];
    if (value) {
      if (value.length > 1) {
        result = [{ value: `${tr.Searching}...`, data: 555, disabled: true }];
        getTourPointAddress(value, update);
      }
    }
    setResult(result);
  };

  const children = result.map((el, i) => {
    if (el && el.data) {
      return {
        value: `${el.value + i}`,
        label: (
          <div>
            <span>{el.value}</span>
            {el.tag ? <Tag>{el.tag.replace('_', ' ')}</Tag> : null}
          </div>
        ),
        rel: el.data,
      };
    }
    return null;
  });

  const placeholder = !isHome ? tr['Set WORK address'] : tr['Set HOME address'];

  if (isActive) {
    return (
      <AutoComplete
        className="set-home-address-wrapper"
        options={children}
        autoFocus
        onSearch={handleSearch}
        onSelect={handleSelect}
        onFocus={() => {
          publish(way.DRIVE_CHANGE_CURSOR_ICON, {
            isEditHome: true,
            id: Type.HOME,
          });
        }}
        onBlur={() => {
          setActive(false);
          setTimeout(() => publish(way.DRIVE_CHANGE_CURSOR_ICON, {}), 500);
        }}
        defaultValue={!isHome ? workAdr : homeAdr}
        dropdownClassName="set-home-address-wrapper"
      >
        <Input placeholder={placeholder} prefix={<HomeOutlined />} />
      </AutoComplete>
    );
  }
  return '';
};

const Actions = (props) => {
  const {
    tr,
    hasUserPermition,
    isTabAll,
    entireTour,
    isTimeDistEnable,
    dependToggleTimeDist,
    isTimeDistAccumuEnable,
    dependToggleTimeDistAccumu,
    getPDF,
    openEmbedModal,
    changeOpenEmbedModal,
    reverse,
  } = props;
  return (
    <div className={hasUserPermition ? 'action view perm' : 'action view'}>
      <Tooltip
        title={tr['Show the entire Tour on the map']}
        placement="topLeft"
      >
        <div className="entireTourDiv" onClick={entireTour} aria-hidden>
          <ShowEntireTourIcon />
        </div>
      </Tooltip>
      {!isTabAll() ? (
        <TimeAndDistanceBetweenPoints
          isTimeDistEnable={isTimeDistEnable}
          toggleTimeDist={dependToggleTimeDist}
          tr={tr}
        />
      ) : null}
      {!isTabAll() ? (
        <TimeAndDistanceAccumulated
          isTimeDistEnable={isTimeDistAccumuEnable}
          toggleTimeDist={dependToggleTimeDistAccumu}
          tr={tr}
        />
      ) : null}

      <Tooltip title={tr['Download PDF']} placement="topLeft">
        <div className="pdfDiv" onClick={getPDF} aria-hidden>
          <DownloadPdfTourIcon />
        </div>
      </Tooltip>

      {!isTabAll() ? (
        <Tooltip title={tr['Reverse tour']} placement="topLeft">
          <div className="reverseDiv" onClick={reverse} aria-hidden>
            <RevertTourIcon />
          </div>
        </Tooltip>
      ) : null}

      <Tooltip title={tr.Embed} placement="topLeft">
        <div className="embedDiv">
          <div
            className="embedDivLayout"
            onClick={() => changeOpenEmbedModal(true)}
            aria-hidden
          >
            <EmbedTourIcon />
          </div>
          <EmbedTourModal
            open={openEmbedModal}
            setOpen={changeOpenEmbedModal}
          />
        </div>
      </Tooltip>
    </div>
  );
};

export const ActionsEdit = (props) => {
  const {
    tr,
    fullScreen,
    fullScreenMode,
    setFullScreen,
    isActiveAddressField,
    toggleAddressField,
    setHomeAddressUser,
    homeAdr,
    workAdr,
    entireTour,
    isTabAll,
    isTimeDistEnable,
    dependToggleTimeDist,
    isTimeDistAccumuEnable,
    dependToggleTimeDistAccumu,
    reverseTour,
    userHomeAs,
    userWorkAs,
    isHome,
  } = props;

  const style = {
    zIndex: 9999999999,
    bottom: 'calc(100vh - 50px)',
  };

  const toolbox = (
    <div className="action edit" style={fullScreen ? style : {}}>
      <SetAddressField
        isActive={isActiveAddressField}
        setActive={toggleAddressField}
        setHomeAddress={setHomeAddressUser}
        homeAdr={homeAdr}
        workAdr={workAdr}
        isHome={isHome}
        tr={tr}
      />

      <Tooltip
        title={tr['Show the entire Tour on the map']}
        placement="topLeft"
      >
        <div className="entireTourDiv" onClick={entireTour} aria-hidden>
          <ShowEntireTourIcon />
        </div>
      </Tooltip>

      <Tooltip title={tr['Full map view']} placement="topLeft">
        <div
          className="fullMapViewDiv"
          onClick={() => fullScreenMode(fullScreen, setFullScreen)}
          aria-hidden
        >
          <FullScreenTourIcon />
        </div>
      </Tooltip>

      <Tooltip title={tr['Set your HOME position']} placement="topLeft">
        <div
          className="setHomePositionDiv"
          onClick={() => toggleAddressField(!isActiveAddressField)}
          aria-hidden
        >
          <HomeSetPositionIcon />
        </div>
      </Tooltip>

      {!isTabAll() ? (
        <TimeAndDistanceBetweenPoints
          isTimeDistEnable={isTimeDistEnable}
          toggleTimeDist={dependToggleTimeDist}
          tr={tr}
        />
      ) : null}

      {!isTabAll() ? (
        <TimeAndDistanceAccumulated
          isTimeDistEnable={isTimeDistAccumuEnable}
          toggleTimeDist={dependToggleTimeDistAccumu}
          tr={tr}
        />
      ) : null}

      {!isTabAll() ? (
        <>
          <Tooltip title={tr['Reverse tour']} placement="topLeft">
            <div className="reverseDiv" onClick={reverseTour} aria-hidden>
              <RevertTourIcon />
            </div>
          </Tooltip>

          <Tooltip
            title={tr['Use home position as start point']}
            placement="topLeft"
          >
            <div
              className="homePositionStartDiv"
              onClick={(e) => userHomeAs(Type.START, toggleAddressField, e)}
              aria-hidden
            >
              <div
                src="#"
                alt="homePositionStart"
                className="homePositionStart"
              >
                <HomeStartIcon />
              </div>
            </div>
          </Tooltip>

          <Tooltip
            title={tr['Use home position as end point']}
            placement="topLeft"
          >
            <div
              className="homePositionEndDiv"
              onClick={(e) => userHomeAs(Type.END, toggleAddressField, e)}
              aria-hidden
            >
              <div src="#" alt="homePositionEnd" className="homePositionEnd">
                <HomeEndIcon />
              </div>
            </div>
          </Tooltip>

          <Tooltip
            title={tr['Use work position as start point']}
            placement="topLeft"
          >
            <div
              className="workPositionStartDiv"
              onClick={(e) => userWorkAs(Type.START, toggleAddressField, e)}
              aria-hidden
            >
              <div
                src="#"
                alt="workPositionStart"
                className="workPositionStart"
              >
                <WorkStartIcon />
              </div>
            </div>
          </Tooltip>

          <Tooltip
            title={tr['Use work position as end point']}
            placement="topLeft"
          >
            <div
              className="workPositionStartDiv"
              onClick={(e) => userWorkAs(Type.END, toggleAddressField, e)}
              aria-hidden
            >
              <div src="#" alt="workPositionEnd" className="workPositionEnd">
                <WorkEndIcon />
              </div>
            </div>
          </Tooltip>
        </>
      ) : null}
    </div>
  );

  return fullScreen
    ? ReactDOM.createPortal(toolbox, document.querySelector('.TourFullmap'))
    : toolbox;
};

const ToolbarLayout = (props) => {
  const { tr, hasUserPermition, currentTourId, closePreview, fullScreenMode } =
    props;
  const dispatch = useDispatch();

  const homeAddress = useSelector((store) => store.userReducer.homeAddress);
  const workAddress = useSelector((store) => store.userReducer.workAddress);
  const isLoggedIn = useSelector((store) => store.authentication.isLoggedIn);
  const loginLoad = useSelector((store) => store.authentication.loginLoad);

  const isEditMode = useSelector((store) => store.tourFullData.isEditMode);

  const multiDay = useSelector((store) => store.tourFullData.data.multiDay);

  const activePartId = useSelector(
    (store) => store.tourFullData.activeMultiPart.id
  );

  const activeTourTab = useSelector(
    (store) => store.tourFullData.activeTourTab
  );

  const fullScreen = useSelector(
    (store) => store.tourFullData.isFullScreenModeEnabled
  );

  const [isTimeDistEnable, toggleTimeDist] = useState(false);
  const [isTimeDistAccumuEnable, toggleTimeDistAccumu] = useState(false);
  const [isTourReversed, setReverseFlag] = useState(false);
  const [isActiveAddressField, toggleAddressField] = useState(false);
  const [isHome, setIsHome] = useState(false);
  const [openEmbedModal, setOpenEmbedModal] = useState(false);

  const homeAdr = homeAddress ? homeAddress.value : '';
  const workAdr = workAddress ? workAddress.value : '';

  const setFullScreen = (val) => dispatch(setFullScreenModeStatus(val));

  const entireTour = () => publish(way.DRIVE_MAP_CENTERING, {});

  const reverseTour = () => publish(way.DRIVE_BUILDER_TOUR_REVERSE, {});

  const isTabAll = () => multiDay === true && activeTourTab === '0';

  const changeOpenEmbedModal = (val) => {
    setOpenEmbedModal(val);
  };

  const reverse = () => {
    setReverseFlag(!isTourReversed);
    reverseTour();
  };

  const dependToggleTimeDist = (flag) => {
    toggleTimeDistAccumu(false);
    toggleTimeDist(flag);
  };

  const dependToggleTimeDistAccumu = (flag) => {
    toggleTimeDist(false);
    toggleTimeDistAccumu(flag);
  };

  const setHomePostion = (data) => dispatch(setHomeAddressUser(data));

  const userHomeAs = (type, setActiontPointType, e = null) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (!isLoggedIn && !loginLoad) {
      notification.warning({
        message: tr['Login to use home address'],
        duration: 0,
        top: 80,
      });
      return;
    }
    const { lat, lng } = homeAddress;
    if ((lat, lng)) {
      const data = {
        lat,
        lng,
        type,
        iconType: `${Type.HOME}_${type}`,
        draggable: true,
      };
      publish(way.DRIVE_MAP_CLICK, data);
    } else {
      console.log('You need to set up you home address');
      setIsHome(true);
      setActiontPointType(type);
    }
    closePreview();
  };

  const userWorkAs = (type, setActiontPointType, e = null) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (!isLoggedIn && !loginLoad) {
      notification.warning({
        message: tr['Login to use work address'],
        duration: 0,
        top: 80,
      });
      return;
    }
    const { lat, lng } = workAddress;
    if ((lat, lng)) {
      const data = {
        lat,
        lng,
        type,
        iconType: `${Type.WORK}_${type}`,
        draggable: true,
      };
      publish(way.DRIVE_MAP_CLICK, data);
    } else {
      console.log('You need to set up you work address');
      setActiontPointType(type);
    }
    closePreview();
  };

  const getPDF = () => {
    const tour = currentTourId || activePartId;
    let href = `${process.env.SERVER_URL}/api/pdf.pdf?scope=tour&object_id=${tour}`;
    if (isTourReversed) href += '&reversT=1';
    window.location.href = href;
  };

  return isEditMode ? (
    <ActionsEdit
      tr={tr}
      fullScreen={fullScreen}
      fullScreenMode={fullScreenMode}
      setFullScreen={setFullScreen}
      isActiveAddressField={isActiveAddressField}
      toggleAddressField={toggleAddressField}
      setHomeAddressUser={setHomePostion}
      homeAdr={homeAdr}
      workAdr={workAdr}
      entireTour={entireTour}
      isTabAll={isTabAll}
      isTimeDistEnable={isTimeDistEnable}
      dependToggleTimeDist={dependToggleTimeDist}
      isTimeDistAccumuEnable={isTimeDistAccumuEnable}
      dependToggleTimeDistAccumu={dependToggleTimeDistAccumu}
      reverseTour={reverseTour}
      userHomeAs={userHomeAs}
      userWorkAs={userWorkAs}
      isHome={isHome}
    />
  ) : (
    <Actions
      tr={tr}
      hasUserPermition={hasUserPermition}
      isTabAll={isTabAll}
      entireTour={entireTour}
      isTimeDistEnable={isTimeDistEnable}
      dependToggleTimeDist={dependToggleTimeDist}
      isTimeDistAccumuEnable={isTimeDistAccumuEnable}
      dependToggleTimeDistAccumu={dependToggleTimeDistAccumu}
      getPDF={getPDF}
      openEmbedModal={openEmbedModal}
      changeOpenEmbedModal={changeOpenEmbedModal}
      reverse={reverse}
    />
  );
};

export default withTranslations(ToolbarLayout);
